import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, apiErrorMessage, formatDate } from "@/lib/api";

const STATUS_COLORS = { synced: "text-green-600", pending: "text-amber-600", failed: "text-red-600" };

export default function AdminContacts() {
  const [contacts, setContacts] = useState([]);
  const [total, setTotal] = useState(0);

  const load = () => api.get("/newsletter/admin/contacts", { params: { limit: 100 } }).then(({ data }) => {
    setContacts(data.items);
    setTotal(data.total);
  });
  useEffect(() => { load(); }, []);

  const retry = async (id) => {
    try {
      await api.post(`/newsletter/admin/contacts/${id}/retry-sync`);
      toast.success("Синхронизацията е поставена на опашка");
      setTimeout(load, 1500);
    } catch (err) {
      toast.error(apiErrorMessage(err));
    }
  };

  return (
    <div data-testid="admin-contacts-page">
      <h1 className="font-serif text-3xl font-bold text-[#1A1A1A] mb-2">Контакти</h1>
      <p className="text-sm text-[#718096] mb-6">Общо {total} контакти, синхронизирани с Brevo list &quot;metri.bg&quot;.</p>
      <div className="bg-white border border-[#E2E8F0] overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#F4F1EC] text-left text-[#718096] uppercase text-xs">
            <tr>
              <th className="px-4 py-3">Имейл</th>
              <th className="px-4 py-3">Източник</th>
              <th className="px-4 py-3">Newsletter</th>
              <th className="px-4 py-3">Brevo статус</th>
              <th className="px-4 py-3">Последна синхр.</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#E2E8F0]">
            {contacts.map((c) => (
              <tr key={c.id} data-testid={`admin-contact-row-${c.email}`}>
                <td className="px-4 py-3 font-medium text-[#1A1A1A]">{c.email}</td>
                <td className="px-4 py-3">{c.source}</td>
                <td className="px-4 py-3">{c.newsletter_consent ? "Да" : "Не"}</td>
                <td className={`px-4 py-3 font-semibold ${STATUS_COLORS[c.brevo_sync_status] || ""}`}>{c.brevo_sync_status}</td>
                <td className="px-4 py-3 text-[#718096]">{c.last_sync_at ? formatDate(c.last_sync_at) : "—"}</td>
                <td className="px-4 py-3">
                  {c.brevo_sync_status !== "synced" && (
                    <Button size="sm" variant="outline" onClick={() => retry(c.id)} data-testid={`admin-contact-retry-${c.email}`}>Retry</Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {contacts.length === 0 && <p className="p-4 text-sm text-[#718096]">Няма контакти все още.</p>}
      </div>
    </div>
  );
}
